import HttpTransport from '@/bundles/Http/transport/HttpTransport';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';
import { generateParams } from '@/helpers/functions';
import { ICategory } from '@/bundles/Category/interfaces';

const resource = '/category';

export default class CategoryService {
  private readonly transport: HttpTransport;
  private readonly errorMapper: ErrorMapper;

  constructor(transport: HttpTransport, errorMapper: ErrorMapper) {
    this.transport = transport;
    this.errorMapper = errorMapper;
  }

  async list(params: any[]): Promise<any> {
    try {
      const paramsString = generateParams(params);
      return await this.transport.get(`${resource}/pagination${paramsString}`);
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }

  async create(payload: ICategory): Promise<any> {
    try {
      return await this.transport.post(`${resource}`, payload);
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }

  async edit({
    id,
    payload
  }: {
    id: string | number;
    payload: ICategory;
  }): Promise<any> {
    try {
      return await this.transport.patch(`${resource}/${id}`, payload);
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }

  async delete(id: string): Promise<any> {
    try {
      return await this.transport.delete(`${resource}/${id}`);
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }
}
